import React from 'react';

const DataTableElement = ({ columns, items, tableLoad, classHead }) => {
  return (
    <div className="overflow-x-auto rounded-xl shadow-md bg-fr-light">
      <div className="overflow-x-auto hidden md:block">
      <table className="min-w-full w-full table-auto border-separate border-spacing-0 text-sm text-left text-fr-dark ">
        <thead className={`sticky top-0  bg-fr-primary text-fr-light ${classHead}`}>
          <tr>
            {columns.map((col) => (
              <th
                key={col.id}
                className="px-4 py-3 font-semibold text-xs uppercase tracking-wide first:rounded-tl-xl last:rounded-tr-xl"
              >
                {col.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableLoad.show ? (
            <tr>
              <td colSpan={columns.length} className="px-6 py-6 text-center">
                <div className="flex justify-center items-center gap-2">
                  <svg
                    className="animate-spin h-5 w-5 text-fr-primary"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  <span>{tableLoad.textLoad ?? 'Cargando...'}</span>
                </div>
              </td>
            </tr>
          ) : items.length ? (
            items.map((item, index) => (
              <tr
                key={item.id}
                className={`transition duration-150 ${
                  index % 2 === 0 ? 'bg-fr-secondary' : 'bg-fr-light'
                } hover:bg-fr-muted`}
              >
                {columns.map((col) => (
                  <td key={col.id} className="px-4 py-3 border-b border-fr-muted text-sm">
                    {col.cell ? col.cell(item) : col.selector(item)}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="px-6 py-6 text-center text-fr-dark">
                <span>No hay registros para mostrar</span>
              </td>
            </tr>
          )}
        </tbody>
      </table>
</div>
      <div className="block md:hidden space-y-4 p-2">
        {tableLoad.show ? (
          <div className="p-4 text-center">Cargando...</div>
        ) : items.length ? (
          items.map((item, index) => (
            <div
              key={item.id}
              className="bg-white rounded-xl border border-fr-muted shadow-sm p-4"
            >
              {columns.map((col, i) => (
                <div key={col.id} className={`py-1 ${i < columns.length - 1 ? 'border-b border-fr-secondary' : ''}`}>
                  <div className="text-[12px] text-fr-dark font-medium uppercase tracking-wide">{col.name}</div>
                  <div className="text-[15px] text-fr-dark font-semibold">{col.cell ? col.cell(item) : col.selector(item)}</div>
                </div>
              ))}
            </div>
          ))
        ) : (
          <div className="p-4 text-center text-fr-dark">No hay registros para mostrar</div>
        )}
      </div>
    </div>
  );
};

export default DataTableElement;
